import clsx from 'clsx';
import ImageBlock from './ImageBlock';
import PromoContentBlock from './PromoContentBlock';

export default function SplitHero({ block, position, entry_uid }) {
  const { block_a, block_b, hide_hero } = block.split_hero;

  return (
    <section
      id={`${entry_uid}_${position}`}
      data-name={'split-hero'}
      className={clsx(
        'hero-content hero-content-split-hero relative mx-auto w-full lg:flex lg:max-h-[617px] lg:px-5 2xl:max-h-[756px] 2xl:max-w-[1680px]',
        { 'hidden!': hide_hero }
      )}
    >
      <PromoContentBlock settings={block_a} position={position} />
      <ImageBlock settings={block_b} position={position} />
    </section>
  );
}
